import UaVideoPlayer from './player';
import UaVideoBg from './background';

// Define the DOM handler for initializing UaVideoPlayer instances
document.addEventListener('DOMContentLoaded', () => {
  // Select all elements with the custom data attribute
  const videoPlayerElements = document.querySelectorAll(`[data-ua-video-player-options]`);

  if (videoPlayerElements.length === 0) {
    // console.warn('No video player elements found.');
    return;
  }

  // Loop through each element and initialize the UaVideoPlayer
  videoPlayerElements.forEach((el) => {
    // Get options from the data attribute
    const options = el.hasAttribute('data-ua-video-player-options')
      ? JSON.parse(el.getAttribute('data-ua-video-player-options'))
      : {};

    // Create a new instance of the UaVideoPlayer class
    new UaVideoPlayer(el, options); // Pass the element and parsed options
  });

  // console.info(`${videoPlayerElements.length} video players initialized.`);
});

document.addEventListener('DOMContentLoaded', () => {
  // Select all elements with the custom data attribute for video backgrounds
  const videoBgElements = document.querySelectorAll('.js-video-bg');

  if (videoBgElements.length === 0) {
    // If no video background elements are found, do nothing
    // console.warn('No video background elements found.');
    return;
  }

  // Loop through each element and initialize the UaVideoBg class
  videoBgElements.forEach((el) => {
    // Get options from the data attribute
    const options = el.hasAttribute('data-ua-video-bg-options')
      ? JSON.parse(el.getAttribute('data-ua-video-bg-options'))
      : {};

    // Create a new instance of the UaVideoBg class
    new UaVideoBg(el, options).init();
  });

  // console.info(`${videoBgElements.length} video background elements initialized.`);
});
